module.exports = __webpack_public_path__ + "img/footer2-2.edabbf24.png";